import React from 'react';

/**
 * Icons.
 */
import ThoughtIcon from 'assets/icons/thought.svg';
import MeditationIcon from 'assets/icons/meditation.svg';
import IntellectualIcon from 'assets/icons/intellectual.svg';
import FamousIcon from 'assets/icons/famous.svg';
import MentalIcon from 'assets/icons/mental.svg';


/**
 * Style.
 */
import './landing-card.scss';

const cardIcon = {
  thought: ThoughtIcon,
  meditation: MeditationIcon,
  intellectual: MentalIcon,
  famous: FamousIcon,
  mental: IntellectualIcon,
};

const LandingCard = ({ icon, title, children }) => (
  <div className="landing-card-wrapper">
    <div className="landing-card-icon-wrapper">
      <div className="landing-card-icon">
        <img src={cardIcon[`${icon}`]} alt="" />
      </div>
    </div>
    <div className="landing-card-title-wrapper">
      {title}
    </div>
    <div className="landing-card-content-wrapper">
      {children}
    </div>
  </div>
);

export default LandingCard;
